<div class="container-fluid d-flex flex-column h-100  w-100">
  <div class="row d-flex justify-content-between mr-2 mb-3">
    <fieldset>
      <div class="d-flex align-items-center px-2">
        <div class="mr-2">
          <button (click)="loadItems()" [ngClass]="{ 'btn-success': isLoading, 'btn-light': !isLoading }"
            class="btn btn-sm">
            <i [ngClass]="{ 'la-spin': isLoading }" class="la la-refresh"></i>
          </button>
        </div>
        <div class="mr-2">
          <button (click)="shiftLeft()" [disabled]="
              isLoading ||
              selectedNodes.length === 0 ||
              auth.isViewer('routing')
            " class="btn btn-sm btn-primary">
            <i class="la la-fw la-chevron-left"></i>
            {{ "navigations.plan.shift_left" | translate }}
          </button>
        </div>
        <div class="mr-2">
          <button (click)="shiftRight()" [disabled]="
              isLoading ||
              selectedNodes.length === 0 ||
              auth.isViewer('routing')
            " class="btn btn-sm btn-primary">
            <i class="la la-fw la-chevron-right"></i>
            {{ "navigations.plan.shift_right" | translate }}
          </button>
        </div>
        <div class="mr-2">
          <button (click)="autoBalance()" [disabled]="
              isLoading ||
              selectedNodes.length === 0 ||
              auth.isViewer('routing')
            " class="btn btn-sm btn-success">
            <i class="la la-fw la-balance-scale"></i>
            {{ "navigations.plan.auto_balance" | translate }}
          </button>
        </div>
        <div class="mr-2">
          <button (click)="openCalendarStartDate()" [disabled]="
              isLoading ||
              auth.isViewer('routing')
            " class="btn btn-sm btn-secondary">
            <i class="la la-fw la-calendar"></i>
            Calendar Start Date
          </button>
        </div>
        <div class="mr-2">
          <button (click)="resetCalendar()" [disabled]="
              isLoading ||
              selectedNodes.length === 0 ||
              auth.isViewer('routing')
            " class="btn btn-sm btn-warning">
            <i class="la la-fw la-undo"></i>
            Reset Calendar
          </button>
        </div>
      </div>
    </fieldset>
  </div>
  <div class="row h-100">
    <div class="flex-column h-100" class="col-12">
      <app-grid [gridUid]="'routing_schedule'" (selectionChanged)="onSelectionChanged($event)"
        (filterChanged)="onFilterChanged($event)" [gridOptions]="gridOptions" [rowData]="items" [pinnedTopRowData]="topRow" class="ag-theme-alpine">
      </app-grid>
    </div>
  </div>
</div>

<!-- Calendar Start Date Modal Template -->
<ng-template #calendarStartDateTpl>
  <div class="modal-header">
    <h5 class="modal-title">Calendar Start Date</h5>
    <button type="button" class="close" aria-label="Close" (click)="bsModalRef?.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <label class="mb-2">Select date</label>
    <input
      type="date"
      class="form-control"
      #dateInput
      [(ngModel)]="selectedCalendarDate"
      (click)="openNativeDatePicker(dateInput)"
    />
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light btn-sm" (click)="bsModalRef?.hide()">Cancel</button>
    <button type="button" class="btn btn-primary btn-sm" [disabled]="!selectedCalendarDate" (click)="confirmCalendarStartDate()">Continue</button>
  </div>
</ng-template>
